import React from 'react';
import {
  AutocompleteInput,
  ReferenceInput,
  ReferenceInputProps,
} from 'react-admin';

interface AutocompleteCohortInputProps
  extends Omit<ReferenceInputProps, 'reference' | 'filterToQuery'> {
  helperText?: string;
}

const AutocompleteCohortInput: React.FC<AutocompleteCohortInputProps> = ({
  source,
  label,
  helperText,
  ...props
}) => (
  <ReferenceInput {...props} source={source} reference="Cohort">
    <AutocompleteInput
      optionText="name"
      label={label}
      helperText={helperText}
      noOptionsText="No active cohorts"
      filterToQuery={(name: string) => ({ name })}
    />
  </ReferenceInput>
);

export default AutocompleteCohortInput;
